export class ShipData {
  shipID!: number
  shipName!: string;
  managerName!: string;
  teamName!: string;
  shipOrderHandlerID!: number;
  shipOrderHandler!: string;
  shipOrderHandlerEmail!: string;
  shipOrderHandlerMobile!: string;
  emailSenderEmail!: string;
  isBackupOrderHandlerActive!: boolean;
  backupOrderHandlerID!: number;
  backupOrderHandler!: string;
  backupOrderHandlerEmail!: string;
  backupOrderHandlerMobile!: string;
  weekendOrderHandlerID: number = 0;
  weekendOrderHandler: string = "";
  weekendOrderHandlerEmail: string = "";
  weekendOrderHandlerMobile: string = "";
}
